// https://vuex.vuejs.org/en/mutations.html


const mutations = {
  setLanguage(state, lang) {
    state.curLanguage = lang;
  },
  setErrorMsg(state, errorMsg) {
    state.errorMsg = errorMsg;
  }

}

export default mutations
